import React from 'react';

import * as TestDefinitionDAO from 'sample-tests/network/TestDefinitionDAO';
import {TEST_DEFINITIONS} from 'sample-tests/ui/test-definitions/TestDefinitionConstants';

import EmptySidebarIcon from './EmptySidebarIcon';
import * as SidebarConstants from './SidebarConstants';
import SidebarItem from './SidebarItem';

const {Section} = SidebarConstants;

interface TestDefinitionSettingsProps {
  section: SidebarConstants.Section;
}

export default function TestDefinitionSettings(props: TestDefinitionSettingsProps): JSX.Element {
  return (
    <div>
      <div className="browser-nav-header">{TEST_DEFINITIONS}</div>
      <SidebarItem
        active={props.section === Section.TEST_DEFINITIONS}
        icon={<EmptySidebarIcon />}
        name={TEST_DEFINITIONS}
        link={TestDefinitionDAO.testDefinitionsListingURL()}
      />
    </div>
  );
}
